export interface SceneData {
  texts: PageText[];
  movies: [
    {
      fileName: string;
      copyrightInfo: string;
      url: string;
    },
  ];
}

interface PageText {
  content: string;
  tags: string[];
}
